import { DOCUMENT } from '@angular/common';
import { InjectionToken, inject } from '@angular/core';
const WINDOW = new InjectionToken('WINDOW', {
  providedIn: 'root',
  factory() {
    const document = inject(DOCUMENT);
    return document.defaultView;
  }
});
const PLATFORM_WINDOW = new InjectionToken('PLATFORM_TOKEN', {
  providedIn: 'platform',
  factory() {
    return window;
  }
});

/**
 * Generated bundle index. Do not edit.
 */

export { PLATFORM_WINDOW, WINDOW };
